export const loadFromStorage = (key: string): any => {
  if (typeof window !== 'undefined') {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  }
  return null;
};

export const saveToStorage = (key: string, value: any): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.log(`Error Saving to Storage -> "${key}: ${value}"`, e);
    }
  }
};

export const removeFromStorage = (key: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
};

export const sessionId: string = loadFromStorage('sessionId');

export const generateUniqueId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const saveDataAgainstUniqueId = (): void => {
  const claims = loadFromStorage('claims');
  const vehicleData = loadFromStorage('userAnswers');
  const currentId = loadFromStorage('currentId');
  const email: string =
    claims?.email ||
    (vehicleData?.['basicInfo'] ? vehicleData['basicInfo']['email'] : vehicleData?.['email']?.[0]);
  const generatedId: string = currentId || generateUniqueId();
  saveToStorage('currentId', generatedId);
  const modifiedVehicleData = {
    [email]: {
      [generatedId]: {
        surname:
          claims?.surname ||
          (vehicleData?.['basicInfo']
            ? vehicleData?.['basicInfo']['surname']
            : vehicleData?.['surname']?.[0]),
        firstName:
          claims?.surname ||
          (vehicleData?.['basicInfo']
            ? vehicleData?.['basicInfo']['givenName']
            : vehicleData?.['givenName']?.[0]),
        dob:
          claims?.surname ||
          (vehicleData?.['basicInfo']
            ? vehicleData?.['basicInfo']['dateOfBirth']
            : vehicleData?.['dateOfBirth']?.[0]),
        lender: claims?.surname || vehicleData?.['lender']?.[0],
        carMake: claims?.surname || vehicleData?.['carMake']?.[0],
        address:
          claims?.surname ||
          (vehicleData?.['basicInfo']
            ? vehicleData?.['basicInfo']['address']?.address
            : vehicleData?.['address.currentAddress']?.[0]?.address ||
              vehicleData?.['address']?.[0]?.address),
        email: email,
        phone: claims?.surname || vehicleData?.['phone']?.[0],
        docusign: claims?.surname || vehicleData?.['docusign']?.[0],
        vehicleRegistrationNumber:
          claims?.surname || vehicleData?.['vehicleRegistrationNumber']?.[0],
      },
    },
  };
  saveToStorage('claims', modifiedVehicleData);
};

export const updateBasicInfo = async (values: any) => {
  const lSInfo = loadFromStorage('userAnswers');
  saveToStorage('userAnswers', {
    ...lSInfo,
    basicInfo: { ...lSInfo?.basicInfo, ...values },
  });
};
